/**
 * API functions for credential management.
 */

import apiClient from './client';
import type { Credential, CredentialCreateRequest } from '@/types/credential';

const BASE = '/v1/credentials';
const ASSETS_BASE = '/v1/assets';

export async function listCredentials(): Promise<Credential[]> {
  const { data } = await apiClient.get<Credential[]>(BASE);
  return data;
}

export async function createCredential(payload: CredentialCreateRequest): Promise<Credential> {
  const { data } = await apiClient.post<Credential>(BASE, payload);
  return data;
}

export async function deleteCredential(credentialId: string): Promise<void> {
  await apiClient.delete(`${BASE}/${credentialId}`);
}

export async function attachCredential(assetId: string, credentialId: string): Promise<void> {
  await apiClient.post(`${ASSETS_BASE}/${assetId}/credentials/${credentialId}`);
}

export async function detachCredential(assetId: string, credentialId: string): Promise<void> {
  await apiClient.delete(`${ASSETS_BASE}/${assetId}/credentials/${credentialId}`);
}
